import KpiAreaChart from "../component/areaChart"
import KpiBarChart from "../component/barChart"
import ListSales from "./list"
import KpiCard from "../component/kpiCard"
import { Skeleton } from "@mui/material"
import { isLoading } from "../component/loading/store"
import { useSelector } from 'react-redux'
import { Grid, Tab, TabList, TabGroup, TabPanel, TabPanels } from "@tremor/react"
import { cumulativeSalesPerDateKPI, cumulativeSalesPerTypeOrderKPI, cumulativeSalesPerWeekKPI, customerCountKPI, orderAverageTicketCustomerKPI, orderAverageTicketKPI, orderCountKPI, orderTotalKPI, salesPerHourKPI, salesPerImportTypeKPI, salesPerTrademarkKPI } from "./helper"
import useTrademarkFilter from "../../hooks/useTrademarkFilter"

export default function Sales() {
    const generalParameters = useSelector(state => state.generalParameters)
    const metaMensalTotal = Array.isArray(generalParameters) ? generalParameters.filter(param => param.chave === "META_MENSAL_VENDAS").reduce((total, item) => total + (Number(item.valor) || 0), 0) : 0
    const kpiSales = useSelector((state) => state.kpiSales)
    const loading = useSelector((state) => isLoading(state, 'KPI_SALES'))

    // faz o filtro das listas de vendas por marca selecionada pelo usuário
    const filteredKpiSales = useTrademarkFilter(kpiSales)

    const cardOrderCountKPI = orderCountKPI(filteredKpiSales)
    const cardCustomerCountKPI = customerCountKPI(filteredKpiSales)
    const cardOrderTotalKPI = orderTotalKPI(filteredKpiSales)
    const cardOrderAverageTicketKPI = orderAverageTicketKPI(filteredKpiSales)
    const cardOrderAverageTicketCustomerKPI = orderAverageTicketCustomerKPI(filteredKpiSales)
    const chartCumulativeSalesPerDateKPI = cumulativeSalesPerDateKPI(filteredKpiSales, metaMensalTotal)
    const chartCumulativeSalesPerWeekKPI = cumulativeSalesPerWeekKPI(filteredKpiSales)
    const chartCumulativeSalesPerTypeOrderKPI = cumulativeSalesPerTypeOrderKPI(filteredKpiSales)
    const chartSalesPerHourKPI = salesPerHourKPI(filteredKpiSales)
    const chartSalesPerImportTypeKPI = salesPerImportTypeKPI(filteredKpiSales)
    const chartSalesPerTrademarkKPI = salesPerTrademarkKPI(filteredKpiSales)

    return (
        <TabGroup className="mt-0">
            <TabList>
                <Tab>Visão geral</Tab>
                <Tab>Listagem</Tab>
            </TabList>

            <TabPanels>
                <TabPanel>
                    {!loading ? (
                        <Grid numItemsSm={1} numItemsMd={2} numItemsLg={3} className="gap-6 mt-6">
                            <KpiCard {...cardOrderCountKPI} />
                            <KpiCard {...cardOrderTotalKPI} />
                            <KpiCard {...cardOrderAverageTicketKPI} />
                            <KpiCard {...cardCustomerCountKPI} />
                            <KpiCard {...cardOrderAverageTicketCustomerKPI} />
                        </Grid>
                    ) : (
                        <Grid numItemsSm={1} numItemsMd={2} numItemsLg={3} className="gap-6 mt-6">
                            <Skeleton variant="rounded" height={150} />
                            <Skeleton variant="rounded" height={150} />
                            <Skeleton variant="rounded" height={150} />
                        </Grid>
                    )}

                    <div className="mt-6">
                        {!loading ? (
                            <KpiAreaChart {...chartCumulativeSalesPerDateKPI} />
                        ) : (
                            <Skeleton variant="rounded" height={400} />
                        )}
                    </div>

                    <div className="mt-6">
                        {!loading ? (
                            <Grid numItemsSm={1} numItemsMd={1} numItemsLg={2} className="gap-6 mt-6">
                                <KpiBarChart {...chartCumulativeSalesPerWeekKPI} />
                                <KpiAreaChart {...chartSalesPerHourKPI} />
                                <KpiBarChart {...chartCumulativeSalesPerTypeOrderKPI} />
                                <KpiBarChart {...chartSalesPerImportTypeKPI} />
                                <KpiBarChart {...chartSalesPerTrademarkKPI} />
                            </Grid>
                        ) : (
                            <Grid numItemsSm={1} numItemsMd={1} numItemsLg={2} className="gap-6 mt-6">
                                <Skeleton variant="rounded" height={400} />
                                <Skeleton variant="rounded" height={400} />
                                <Skeleton variant="rounded" height={400} />
                                <Skeleton variant="rounded" height={400} />
                            </Grid>
                        )}
                    </div>
                </TabPanel>

                <TabPanel>
                    <ListSales data={Array.isArray(kpiSales.listAllSales) ? kpiSales.listAllSales : []} />
                </TabPanel>
            </TabPanels>
        </TabGroup>
    )
}